import React from 'react';
import { dayNamesFromMonday as dayNames } from '../../lib/format/Language';
import {
  formattedTimeFromAppointment,
  getDayIndexStartedFromMonday
} from '../../util';
import { DefaultDateFormatter, intl } from '../../lib';
import { HBox } from '../layout';
import { Icon } from '../basic';

export interface AppointmentDateAndTimeProps {
  appointmentStart: string;
  classNameTitle?: string;
}

export function AppointmentDateAndTime({
  appointmentStart,
  classNameTitle,
  ...props
}: Readonly<AppointmentDateAndTimeProps>): JSX.Element {
  return (
    <HBox {...props} className="ehs-appointment-date-time date-info">
      <Icon
        iconName="shui_clock"
        className="date-icon color-black"
        aria-label={intl('common.date')}
      />
      <div className="date-info-text">
        <div className={classNameTitle}>
          <b>
            {appointmentStart && (
              <>
                {
                  dayNames[
                    getDayIndexStartedFromMonday(new Date(appointmentStart))
                  ]
                }
                ,{' '}
              </>
            )}
            {DefaultDateFormatter.formatDate(appointmentStart)}
          </b>
        </div>
        <span style={{ color: 'var(--text-55)' }}>
          {formattedTimeFromAppointment(appointmentStart)}
        </span>
      </div>
    </HBox>
  );
}
